import React, {useCallback, useEffect, useState} from 'react';
import {reactLocalStorage} from 'reactjs-localstorage';
import LoginForm from "../component/LoginForm";
import {Box, Flex, Image} from "@chakra-ui/react";
import {useHistory} from "react-router-dom";
import Popup from "../component/Popup";
import AlertForCreator from "../component/AlertForCreator";
import Loading from "../component/Loading";
import './LoginPage.css'

const axios = require('axios');
const ENV = require('../ENV.json')
axios.defaults.withCredentials = true;


const LoginPage = (props) => {

    const [modalOpen, setModalOpen] = useState(false);
    const [popupData, setPopupData] = useState({});
    const [isLoading, setIsLoading] = useState(false);

    const history = useHistory();

    //Questa funzione permette di effettuare il login per accedere al form
    const executeLogin = useCallback((data) => {
        //console.log(data);
        setIsLoading(true);
        axios.post(`${ENV[ENV.ENV_STATE].baseUrl}/login`, data, {withCredentials: true})
            .then(function (response) {
                setIsLoading(false);
                setPopupData(response?.data);

                //TAKE ID OF USER (I want use it inside application when i need it globally
                reactLocalStorage.setObject('User', {
                    ID: response?.data?.rows[0]?.ID || -1,
                    name: response?.data?.rows[0]?.name || "Utente",
                    surname: response?.data?.rows[0]?.surname || "Speciale",
                });

                setModalOpen(true);
                if (response?.data?.status) {
                    //il JWT è stato già eventualmente salvato nei cookie e disponibile in ogni richiesta se necessario
                    //console.log("Cambiamo schermata")
                    history.push("/lab");
                }
            })
            .catch(function (error) {
                setIsLoading(false);
                setPopupData({
                    status: false,
                    title: 'Errore imprevisto',
                    message: 'Attenzione, al momento potrebbero esserci problemi di comunicazione'
                });
                setModalOpen(true);
            });
    }, [])

    //TEST
    useEffect(()=>{
        console.log("Abbiamo settato User a null")
        reactLocalStorage.setObject('User',null);
    },[]);


    return (
        <Box {...props.pageProps} className="login_wrap_box">
            <Flex justifyContent="center" flexDirection="row" gap=" 10px">
                <Image height="100px" src='logo_o-min.png'/>
            </Flex>
            <Box className="login_box">
                <LoginForm
                    onLogin={(data) => {
                        executeLogin(data);
                    }}
                />
                <div style={{height: '10px'}}/>
                <Popup
                    isOpen={modalOpen}
                    onClose={() => setModalOpen(false)}
                    popupData={popupData}
                >
                </Popup>
                <Loading isLoading={isLoading}/>
            </Box>
        </Box>
    );
}

export default LoginPage;
